import { Injectable } from '@angular/core';
import {
  BulkReplaceTaxRulesRequest,
  Consumer,
  ListTaxRulesRequest,
  ListTaxRulesRequestFilters,
  PagedRequestOptions,
  ReplaceTaxRuleRequest,
  TaxApiService,
  TaxRuleType as ApiTaxRuleType,
} from '@vendasta/billing';
import { PagedResponse } from '../core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ListTaxRulesFilter,
  TaxRule,
  TaxRuleEntityType,
  taxRuleEntityTypeToApi,
  taxRuleFromApi,
  taxRulesToReplaceTaxRuleApi,
  TaxRuleType,
} from './tax-rule';
import { HttpResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TaxRuleService {
  constructor(private taxApi: TaxApiService) {}

  // lists retail TaxRules for a merchant
  list(filters: ListTaxRulesFilter, cursor: string, pageSize: number): Observable<PagedResponse<TaxRule>> {
    const req = new ListTaxRulesRequest({
      filters: new ListTaxRulesRequestFilters({
        merchantId: filters.merchantId,
        consumer: Consumer.CONSUMER_RETAIL,
        entityType: taxRuleEntityTypeToApi(filters.entityType),
      }),
      pagingOptions: new PagedRequestOptions({ cursor, pageSize }),
    });
    return this.taxApi.listTaxRules(req).pipe(
      map((response) => {
        const taxRates = (response.taxRules || []).map((item) => taxRuleFromApi(item));
        return new PagedResponse(taxRates, response.pagingMetadata.nextCursor, response.pagingMetadata.hasMore);
      }),
    );
  }

  replaceTaxRule(
    merchantId: string,
    entityType: TaxRuleEntityType,
    entityId: string,
    taxRateIds: string[],
    taxRuleType: TaxRuleType,
  ): Observable<{ id: string }> {
    const req = new ReplaceTaxRuleRequest({
      merchantId: merchantId,
      entityType: taxRuleEntityTypeToApi(entityType),
      entityId: entityId,
      type:
        taxRuleType === TaxRuleType.EXEMPTION
          ? ApiTaxRuleType.TAX_RULE_TYPE_EXEMPTION
          : ApiTaxRuleType.TAX_RULE_TYPE_UNSET,
      taxRateIds: taxRateIds,
      consumer: Consumer.CONSUMER_RETAIL,
    });
    return this.taxApi.replaceTaxRule(req);
  }

  bulkReplaceTaxRules(taxRules: TaxRule[]): Observable<{ ids: string[] }> {
    const req = new BulkReplaceTaxRulesRequest({
      taxRules: taxRulesToReplaceTaxRuleApi(taxRules),
    });
    return this.taxApi.bulkReplaceTaxRules(req);
  }

  delete(id: string): Observable<HttpResponse<null>> {
    return this.taxApi.deleteTaxRule({ id: id });
  }
}
